import type { Event } from '@sentry/nextjs';

const LOCALHOST_HOSTNAMES = new Set(['localhost', '127.0.0.1', '0.0.0.0', '::1']);

export function filterLocalhost<TEvent extends Event>(event: TEvent): TEvent | null {
  // oxlint-disable-next-line no-null -- Sentry requires null from beforeSend to drop an event.
  return isLocalhostEvent(event) ? null : event;
}

function isLocalhostEvent(event: Event): boolean {
  const url = event.request?.url;
  if (!url) return false;

  try {
    return LOCALHOST_HOSTNAMES.has(new URL(url).hostname);
  } catch {
    return false;
  }
}
